import Hammer from 'hammerjs';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import Icon from '../Atoms/Icon';
import ErrorBoundary from '../Core/ErrorBoundary';
import Picture from '../Picture';

const propTypes = exact({
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  sideButtons: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
});

const defaultProps = {
  sideButtons: false,
  title: null,
  subTitle: null,
  description: null,
};

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.carousel = null;
    this.touchManager = null;

    this.addTouchSwipe = this.addTouchSwipe.bind(this);
    this.handleSwipeLeft = this.handleSwipeLeft.bind(this);
    this.handleSwipeRight = this.handleSwipeRight.bind(this);

    this.state = { activeSlideIndex: 0 };
  }

  componentDidMount() {
    setTimeout(this.addTouchSwipe, 0);
  }

  componentWillUnmount() {
    if (this.touchManager) {
      this.touchManager.off('swipeleft');
      this.touchManager.off('swiperight');
    }
  }

  addTouchSwipe() {
    if (!this.carousel) return;

    this.touchManager = new Hammer.Manager(this.carousel, { touchAction: 'pan-y' });
    const swipe = new Hammer.Swipe();

    this.touchManager.add(swipe);
    this.touchManager.on('swipeleft', this.handleSwipeLeft);
    this.touchManager.on('swiperight', this.handleSwipeRight);
  }

  handleSwipeLeft() {
    if (this.state.activeSlideIndex >= this.props.items.length - 1) return;
    this.handleSlideRequest(this.state.activeSlideIndex + 1);
  }

  handleSwipeRight() {
    if (this.state.activeSlideIndex <= 0) return;
    this.handleSlideRequest(this.state.activeSlideIndex - 1);
  }

  handleSlideRequest(index) {
    this.setState({ activeSlideIndex: index });
  }

  render() {
    const statuses = this.props.items.map((item, index) => {
      if (index === this.state.activeSlideIndex) return 'active';
      if (index > this.state.activeSlideIndex) return 'next';
      if (index < this.state.activeSlideIndex) return 'previous';
      return null;
    });
    const { items, sideButtons, title, subTitle, description } = this.props;

    return (
      <ErrorBoundary>
        <div className="Carousel">
          <div
            className="Carousel_content"
            ref={(element) => {
              this.carousel = element;
            }}
          >
            <ul className="Carousel_slider">
              {items.map((item, index) => (
                <li key={item.url} className={`Carousel_slide ${statuses[index]}`}>
                  <Picture
                    {...item}
                    className="Carousel_image"
                    sizes={[
                      [100, 1.77], // from 0
                      [100, 1.77], // from 480
                      [100, 1.77], // from 768
                      [100, 1.77], // from 1024
                      [100, 1.77], // from 1440
                    ]}
                  />
                </li>
              ))}
            </ul>
            {items.length > 1 && (
              <>
                <ul className="Carousel_navigationList">
                  {items.map((item, index) => (
                    <li key={item.url} className="Carousel_navigationItem">
                      <button
                        aria-label={`Carousel Slide ${index + 1}`}
                        type="button"
                        onClick={() => this.handleSlideRequest(index)}
                        className={`Carousel_navigationButton ${statuses[index]}`}
                      />
                    </li>
                  ))}
                </ul>
                {sideButtons && (
                  <div className="Carousel_sideButtons">
                    <button
                      type="button"
                      className={`Carousel_leftButton${
                        this.state.activeSlideIndex === 0 ? ' Carousel_leftButton-hidden' : ''
                      }`}
                      onClick={() => this.handleSwipeRight()}
                    >
                      <Icon id="arrow-left" />
                    </button>
                    <button
                      type="button"
                      className={`Carousel_rightButton${
                        this.state.activeSlideIndex === items.length - 1
                          ? ' Carousel_rightButton-hidden'
                          : ''
                      }`}
                      onClick={() => this.handleSwipeLeft()}
                    >
                      <Icon id="arrow-right" />
                    </button>
                  </div>
                )}
              </>
            )}
            {title && (
              <div className="Carousel_textContent">
                {subTitle && <h2 className="Carousel_subTitle">{subTitle}</h2>}
                <h1 className="Carousel_title">{title}</h1>
                {description && <p className="Carousel_description">{description}</p>}
              </div>
            )}
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

export default Carousel;
